module.exports = __webpack_public_path__ + "static/media/openfleet-logo.319beaa0.png";